var $parse;
let promises = [];

class UserApiDirective {
	constructor(_$parse) {
		$parse = _$parse;
		this.restrict = 'A';
	}

	controller() {
		this.$promises = promises;
		console.log('UserApiDirective Controller', this);
	}

	link(scope, elem, attrs) {
		var submit = elem.find('button[user-api-submit]');

		submit.on('click', () => {
			var user = $parse(attrs.userModel)(scope);
			let arr = [];
			promises.forEach((fn) => {
				arr.push(new Promise(fn(user)));
			});
			Promise.all(arr).then((returns) => {
				$parse(attrs.userApi)(scope, {
					'$values': returns
				});
			});
		});
	}

	static directiveFactory($parse){
		return new UserApiDirective($parse);
	}
}

var factory = UserApiDirective.directiveFactory;
factory.$inject = ['$parse'];

export default factory;


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/orgchart/directive.UserApi.es6.js